import { render, staticRenderFns } from "./RegistrationPersonalDataPage.vue?vue&type=template&id=3357177a&scoped=true"
import script from "./RegistrationPersonalDataPage.vue?vue&type=script&lang=ts"
export * from "./RegistrationPersonalDataPage.vue?vue&type=script&lang=ts"
import style0 from "./RegistrationPersonalDataPage.vue?vue&type=style&index=0&id=3357177a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3357177a",
  null
  
)

export default component.exports